<style>
.wz-navbar {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  background: #BB1419;
  height: 0.88rem;
}
.wz-navbar dl,
.wz-navbar dd,
.wz-navbar dt {
  margin: 0;
  padding:0;
}
.wz-navbar .hd_uinfo {
  position: absolute;
  top: 50%;
  left: .3rem;
  width: 50%;
  height:  0.56rem;
  margin-top: -0.28rem;
}
.wz-navbar .hd_uinfo dd,
.wz-navbar .hd_uinfo dt {
  float: left;
}
.wz-navbar .hd_uinfo a {
  display: block;
  height:  0.56rem;
}
.wz-navbar .hd_ulogo {
  width:  0.56rem;
  height:  0.56rem;
}
.wz-navbar .hd_ulogo img {
  width:  0.56rem;
  height:  0.56rem;
  border: 1px solid #979797;
  border-radius: 4px;
}
.wz-navbar .hd_nick {
  color: #666;
  position: absolute;
  top: 0;
  left:  0.72rem;
  font-size:  0.32rem;
  line-height:  0.56rem;
  vertical-align: middle;
  color: #fff;
}
.wz-navbar .hd_nick span {
  float: left;
}
/* .wz-navbar .hd_nick.vip:after {
  height:  0.26rem;
  width:  0.46rem;
  content: " ";
  display: inline-block;
  background: url("../../img/1.0/icon_vip_sm.png") 0 0 no-repeat;
  background-size: contain;
  vertical-align: middle;
  margin-left:  0.05rem;
} */
.wz-navbar .hd_btns {
  position: absolute;
  top: 50%;
  right: 0.3rem;
  height:  0.4rem;
  margin-top:  -0.2rem;
  text-align: center;
}
.wz-navbar .hd_btns a,
.wz-navbar .hd_btns a:visited {
  font-size:  0.34rem;
}
.wz-navbar .hd_btns dd {
  float: left;
  padding-right: .3rem;
}

.wz-navbar .hd_btns a,
.wz-navbar .hd_btns a:visited {
  color: #fff;
}
.wz-navbar .hd_btn-login a,
.wz-navbar .hd_btn-login a:visited {
  color: #D3B06D;
}

</style>

<template>
    <div class="wz-navbar">
        <div class="wz-navbar-inner" v-if="userInfo">
          <div class="hd_uinfo">
            <a href="javascript:;" class="hd_ulogo">
              <img :src="userInfo.logoSrc" :alt="userInfo.nick">
            </a>
            <a href="javascript:;" class="hd_nick">{{userInfo.nick}}</a>
          </div>
          <dl class="hd_btns">
            <dd class="hd_btn-login"><a :href="urlKline">免费体验</a></dd>
            <dd class="hd_btn-logout"><a href="javascript:;" x-click="go.logout">退出</a></dd>
          </dl>
        </div>
        <div class="wz-navbar-inner" v-else>
          <dl class="hd_btns">
            <dd class="hd_btn-login"><a href="javascript:;" x-click="go.login">立即登录</a></dd>
            <dd class="hd_btn-logout"><a href="javascript:;" x-click="go.register">注册</a></dd>
          </dl>
        </div>
    </div>
</template>

<script>
    import {
        mapState,
        mapGetters
    } from 'vuex';
    export default {
        data() {
            return {}
        },
        mounted() {},
        props: [],
        computed: {
          ...mapState(['userInfo']),
          ...mapGetters(['urlKline'])
        },
        methods: {
            
        }
    }

</script>
